import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const TermsConditionsPage = () => (
  <LegalPageLayout title="Terms & Conditions">
    <p className="text-white/60 text-sm">Last updated: {new Date().toLocaleDateString('en-US')}</p>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">1. Acceptance of Terms</h2>
      <p>
        By accessing or using Dial-Grid ("the Service"), you agree to be bound by these Terms & Conditions. If you do not agree, do not use the Service. We may update these terms from time to time; continued use after changes constitutes acceptance.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">2. Description of Service</h2>
      <p>
        Dial-Grid provides a CRM and accounting platform for luxury watch dealers, including inventory management, client management, sales tracking, invoicing, and related business tools. We reserve the right to modify, suspend, or discontinue any part of the Service with reasonable notice.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">3. Account Registration and Approval</h2>
      <p>
        You must provide accurate information when registering. New accounts may require admin approval before full access. You are responsible for maintaining the security of your account and for all activity under it. You must notify us immediately of any unauthorized use.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">4. Acceptable Use</h2>
      <p>
        You agree to use the Service only for lawful purposes and in accordance with these Terms. You may not use the Service to violate any law, infringe on others' rights, transmit harmful content, or attempt to gain unauthorized access to our systems or other users' data.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">5. Fees and Payment</h2>
      <p>
        Subscription fees are as stated at the time of signup. You authorize us to charge your payment method on a recurring basis. Fees are non-refundable except as required by law or as stated in our refund policy. We may change fees with advance notice.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">6. Intellectual Property</h2>
      <p>
        Dial-Grid and its content, features, and functionality are owned by us and are protected by copyright, trademark, and other laws. You may not copy, modify, or create derivative works without our written permission.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">7. Limitation of Liability</h2>
      <p>
        The Service is provided "as is." We disclaim warranties to the fullest extent permitted by law. Our liability for any claim arising from your use of the Service shall not exceed the fees you paid us in the twelve months preceding the claim.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">8. Contact</h2>
      <p>
        For questions about these Terms, contact us at legal@dial-grid.com.
      </p>
    </section>
  </LegalPageLayout>
);

export default TermsConditionsPage;
